import React from 'react'
import './style.css'


function Skeleton(){

    const tag_headers = [
        {separator: false},
        {separator: true},
        {separator: true},
    ]

    return (
        <div class="reactive-form-skeleton">
            <div class="reactive-form-tab-headers">
                {tag_headers.map((tab, i) => (
                    <div 
                        key={i} 
                        class='reactive-form-tab-headers-item'
                    >
                        <div class="svg-icon skeleton-svg-icon">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle class="icon-part icon-part-circle skeleton-svg-fill" style={{stroke:'transparent'}} cx="12" cy="12" r="11.5" fill="white" />
                                <path class="icon-part icon-part-check" style={{stroke:'transparent'}} d="M16.4006 8.69946L10.3506 14.7495L7.60059 11.9995" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="reactive-form-tab-headers-item__title">
                            <div class="skeleton-element skeleton-span"></div>
                        </div>
                        {tab.separator && (
                            <div class="reactive-form-tab-headers-item__separator"></div>
                        )}
                    </div>
                ))}
            </div>
            <div class="reactive-form-tab-body -active">
                    <div class="reactive-form-tab-body__inner">
                        <div class="f-row">
                            <div class="f-col f-col-lg-3 f-col-12">
                                <div class="skeleton-element skeleton-page-heading page-heading -underline"></div>
                            </div>
                            <div class="f-col f-col-lg-9 f-col-12">
                                <div class="f-row f-g-4">
                                    <div class="f-col f-col-12">
                                        <div class="f-row f-g-4">
                                            <div class="f-col f-col-12">
                                                <div class="reactive-form-flex-row">
                                                    <div class="skeleton-element skeleton-field -switcher"></div>
                                                    <div class="skeleton-element skeleton-field -switcher"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="f-col f-col-12">
                                        <div class="f-row f-g-4">
                                            <div class="f-col f-col-lg-6 f-col-12">
                                                {/* <div class="skeleton-element skeleton-field -text"></div> */}
                                                <div class="base-form-field skeleton-form-field">
                                                    <div class="form__label skeleton-form-field__label"></div>
                                                    <div class="form__field js-form-field skeleton-form-field__inner"></div>
                                                </div>
                                            </div>
                                            <div class="f-col f-col-lg-4 f-col-12">
                                                {/* <div class="skeleton-element skeleton-field -date"></div> */}
                                                <div class="base-form-field skeleton-form-field">
                                                    <div class="form__label skeleton-form-field__label"></div>
                                                    <div class="form__field js-form-field skeleton-form-field__inner"></div>
                                                </div>
                                            </div>
                                            <div class="f-col f-col-lg-2 f-col-12">
                                                {/* <div class="skeleton-element skeleton-field -time"></div> */}
                                                <div class="base-form-field skeleton-form-field">
                                                    <div class="form__label skeleton-form-field__label"></div>
                                                    <div class="form__field js-form-field skeleton-form-field__inner"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="f-col f-col-12">
                                        <div class="f-row f-g-4">
                                            <div class="f-col f-col-lg-6 f-col-12">
                                                {/* <div class="skeleton-element skeleton-field -textarea"></div> */}
                                                <div class="base-form-field skeleton-form-field">
                                                    <div class="form__label skeleton-form-field__label"></div>
                                                    <div class="form__field js-form-field skeleton-form-field__inner"></div>
                                                </div>
                                            </div>
                                            <div class="f-col f-col-lg-6 f-col-12">
                                                {/* <div class="skeleton-element skeleton-field -textarea"></div> */}
                                                <div class="base-form-field skeleton-form-field">
                                                    <div class="form__label skeleton-form-field__label"></div>
                                                    <div class="form__field js-form-field skeleton-form-field__inner"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="reactive-form-buttons">
                        <div class="skeleton-element skeleton-button"></div>
                        <div class="skeleton-element skeleton-button -fill"></div>
                    </div>
                </div>
        </div>
    )
}

export default Skeleton